import { useQuery } from '@tanstack/react-query';
import Api from "../api/Api";
import { QUERY_KEYS } from "./queryKeys";
import { useMarkerStore } from "../store/markerStore";
import { useEffect } from "react";

export const useOverlayShapeFile = (dataset: string) => {
  const enabled = !!dataset && dataset !== '';

  return useQuery({
    queryKey: [QUERY_KEYS.map.overlay.shapeFile, dataset],
    queryFn: () => Api.fileEndPoint.getOverlayTree2(dataset),
    enabled
  });
};

export const useOverlaySurfaceMap = (dataset: string) => {
  const enabled = !!dataset && dataset !== '';

  return useQuery({
    queryKey: [QUERY_KEYS.map.overlay.surfaceMap, dataset],
    queryFn: () => Api.fileEndPoint.getOverlayTree(dataset),
    enabled
  });
};

export const useOverlayData = (dataset: string) => {
  const updateMarker = useMarkerStore(state => state.updateMarker);
  const activeMarker = useMarkerStore(state => state.activeMarker);
  const shapeFileQuery = useOverlayShapeFile(dataset);
  const surfaceMapQuery = useOverlaySurfaceMap(dataset);

  useEffect(() => {
    if (activeMarker?.id) {
      if (shapeFileQuery.data) {
        updateMarker(activeMarker.id, { shapeFiles: shapeFileQuery.data });
      }

      if (surfaceMapQuery.data) {
        updateMarker(activeMarker.id, { surfaceMaps: surfaceMapQuery.data });
      }
    }
  }, [
    shapeFileQuery.data,
    surfaceMapQuery.data,
    activeMarker?.id,
    updateMarker
  ]);

  return {
    shapeFileData: shapeFileQuery.data,
    surfaceMapData: surfaceMapQuery.data,
    isLoading: shapeFileQuery.isLoading || surfaceMapQuery.isLoading,
    isError: shapeFileQuery.isError || surfaceMapQuery.isError
  };
};
